export default {
  'notification.page.title': 'Quản lý thông báo hệ thống',
  'notification.page.subtitle': 'Gửi thông báo trong ứng dụng cho các nhóm người dùng mục tiêu',
  'notification.alert.title': 'Nhắm mục tiêu chính xác',
  'notification.alert.description': 'Sử dụng các bộ lọc bên dưới để nhắm mục tiêu chính xác các nhóm người dùng dựa trên hoạt động và trạng thái tài khoản của họ.',
  'notification.card.target.title': 'Đối tượng mục tiêu',
  'notification.card.target.matching': 'Ví khớp điều kiện:',
  'notification.form.specificWallet.label': 'Danh sách địa chỉ ví (Tùy chọn)',
  'notification.form.specificWallet.placeholder': 'Nhập một hoặc nhiều địa chỉ ví (cách nhau bởi dấu phẩy hoặc xuống dòng)...',
  'notification.form.criteria.divider': 'Tiêu chí lọc',
  'notification.form.level.label': 'Cấp độ người dùng',
  'notification.form.level.all': 'Tất cả cấp độ',
  'notification.form.level.L1': 'Cấp độ 1',
  'notification.form.level.L2': 'Cấp độ 2',
  'notification.form.xStatus.label': 'Trạng thái X (Twitter)',
  'notification.form.tgStatus.label': 'Trạng thái Telegram',
  'notification.form.gmailStatus.label': 'Trạng thái Gmail',
  'notification.form.status.all': 'Tất cả',
  'notification.form.status.linked': 'Đã liên kết',
  'notification.form.status.unlinked': 'Chưa liên kết',
  'notification.card.content.title': 'Nội dung tin nhắn',
  'notification.form.contentEn.label': 'Nội dung tiếng Anh',
  'notification.form.contentVi.label': 'Nội dung tiếng Việt',
  'notification.form.content.placeholder': 'Viết thông báo hoặc cập nhật hệ thống của bạn tại đây...',
  'notification.form.content.required': 'Vui lòng nhập nội dung thông báo',
  'notification.form.content.extra': 'Thông báo này sẽ được hiển thị trên chuông thông báo của người dùng dựa trên ngôn ngữ của họ.',
  'notification.button.send': 'Gửi thông báo',
  'notification.confirm.title': 'Xác nhận gửi?',
  'notification.confirm.content': 'Bạn có chắc chắn muốn gửi thông báo này cho {count} người dùng? Hành động này không thể hoàn tác.',
  'notification.success.sent': 'Đã gửi thành công cho {count} người dùng.',
};
